import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import GetTheAppLinks from '~/constants/GetTheAppLinks';
import StyledComponent from '~/components/Styled/Styled';

import BixbyMatchup from '~/components/Bixby/BixbyMatchup/BixbyMatchup';
import BixbyTeamRiver from '~/components/Bixby/BixbyTeamRiver/BixbyTeamRiver';
import Button from '~/components/Button/Button';
import css from '~/components/Bixby/LandingOne/LandingOne.scss';

import logEvent from '~/util/analytics';

const defaultCopy = { part1: 'BIXBY USERS:', part2: 'GET THE FULL', part3: 'BOX SCORE EXPERIENCE' };

const copy = {
  teams: { part1: 'GET THE FULL', part2: 'TEAM COVERAGE', part3: '' },
  events: { part1: 'GET THE FULL', part2: 'BOX SCORE', part3: 'EXPERIENCE' },
};
const getCopy = section => get(copy, `[${section}]`, defaultCopy);

// eslint-disable-next-line react/prefer-stateless-function
class BixbyLandingOne extends React.Component {
  constructor(props) {
    super(props);

    this.trackGetTheAppClick = this.trackGetTheAppClick.bind(this);
  }

  trackGetTheAppClick() {
    logEvent('conversion', {
      campaign: 'thescoreapp',
      type: `bixby_landing_page_${this.props.section}`,
    });
  }

  render() {
    const branchLink =
      this.props.section === 'events'
        ? GetTheAppLinks.bixby_events_link
        : GetTheAppLinks.bixby_teams_link;
    const copyParts = getCopy(this.props.section);
    return (
      <div className={css.container}>
        <div
          className={css.matchup}
          style={{
            backgroundImage: `url(/static/images/bixby/alerts-${this.props.leagueSlug}.png)`,
            minHeight: this.props.section === 'events' ? '60%' : '65%',
          }}
        >
          <div className={css.logo} />
          {this.props.section === 'events' &&
            this.props.object && <BixbyMatchup event={this.props.object} />}
          {this.props.section === 'teams' &&
            this.props.object && <BixbyTeamRiver team={this.props.object} />}
        </div>
        <div className={css.getTheAppContainer}>
          <div
            style={this.props.section === 'events' ? { padding: '18px 0' } : { padding: '20px 0' }}
          >
            <div className={css.getTheAppTxtSmall}>{copyParts.part1}</div>
            <div className={css.getTheAppTxtLarge}>{copyParts.part2}</div>
            <div className={css.getTheAppTxtSmall}>{copyParts.part3}</div>
          </div>
          <div className={css.getTheAppButton}>
            <a href={branchLink} onClick={this.trackGetTheAppClick}>
              <Button
                copy="Get the app"
                height="41px"
                borderRadius="20.5px"
                fontSize="16px"
                hasGradient={false}
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

BixbyLandingOne.propTypes = {
  leagueSlug: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  object: PropTypes.object.isRequired,
};

BixbyLandingOne.displayName = 'BixbyLandingOne';

export default StyledComponent(BixbyLandingOne, [css]);
